<template>
  <span>
    <component
      :is="tag"
      :href="isAnchor ? '#' : undefined"
      :class="btnClass"
      role="button"
      @click.prevent="handleClick"
      @keydown.enter.prevent="handleClick"
      :aria-haspopup="true"
      :aria-controls="lightboxId"
      :aria-expanded="visible.toString()"
    >
      <slot>{{ defaultText }}</slot>
    </component>

    <Lightbox
      v-model:visible="visible"
      :slug="computedSlug"
      :type="type"
      @close="onClose"
      :id="lightboxId"
    />
  </span>
</template>

<script>
import Lightbox from './Lighbox.vue';

export default {
  name: 'LightboxLink',
  components: { Lightbox },
  props: {
    // slug string (preferred) or pass a post object with a `.slug` field
    slug: { type: String, default: null },
    post: { type: Object, default: null },
    type: { type: String, default: 'post' },
    // render as 'a' or 'button' or other element
    tag: { type: String, default: 'a' },
    // optional class for the link/button
    btnClass: { type: [String, Object, Array], default: '' },
    // fallback slot text
    defaultText: { type: String, default: 'Open' }
  },
  data() {
    return {
      visible: false,
      lightboxId: `lh-lightbox-${Math.random().toString(36).slice(2, 9)}`
    };
  },
  computed: {
    computedSlug() {
      if (this.slug) return this.slug;
      if (this.post && (this.post.slug || (this.post.slug === ''))) return this.post.slug;
      // support legacy `post.slug` or `post.post_name` if present
      if (this.post && this.post.post_name) return this.post.post_name;
      return null;
    },
    isAnchor() {
      return this.tag === 'a';
    }
  },
  methods: {
    handleClick() {
      if (!this.computedSlug) {
        // no slug -> emit event so parent can handle (or ignore)
        this.$emit('missing-slug');
        return;
      }
      this.open();
    },
    open() {
      this.visible = true;
      this.$emit('open', { slug: this.computedSlug, type: this.type });
    },
    onClose() {
      this.visible = false;
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* lightweight defaults so link looks like a link unless styled by parent */
a, button {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  background: transparent;
  border: none;
  padding: 0;
  font: inherit;
}
</style>